import { Phone } from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';
import { getRegisterLink } from '../config/externalLinks';

type IconProps = SVGProps<SVGSVGElement>;

function InstagramIcon({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
      {...props}
    >
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
    </svg>
  );
}

function YoutubeIcon({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
      {...props}
    >
      <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
      <path d="m10 15 5-3-5-3z" />
    </svg>
  );
}

const socialLinks: { label: string; href: string; Icon: ComponentType<IconProps> }[] = [
  { label: 'Teléfono', href: 'https://walink.co/s7fd5u', Icon: Phone },
  { label: 'Instagram', href: 'https://www.instagram.com/protorneos.com_/', Icon: InstagramIcon },
  { label: 'Youtube', href: 'https://www.youtube.com/@protorneos', Icon: YoutubeIcon },
];
const registerLink = getRegisterLink()

export function CtaFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-8 border-t border-brand-border">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 sm:px-6 lg:px-8">
        <section className="relative overflow-hidden rounded-2xl border border-brand-border bg-gradient-to-r from-brand-deep via-brand-panel to-brand-deep px-5 py-12 text-center sm:px-8">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(215,194,4,0.15),transparent_55%)]" />
          <div className="relative">
            <h3 className="font-display text-4xl font-extrabold leading-tight sm:text-5xl">
              ¿Todo listo para transformar la gestión de tu torneo?
            </h3>
            <a
              href={registerLink}
              target="_blank"
              rel="noopener noreferrer"
              className="action-btn mt-7 inline-block bg-brand-yellow px-8 py-3 text-base font-bold text-black hover:bg-brand-yellow/85"
            >
              Comenzá gratis ahora
            </a>
          </div>
        </section>

        <div className="mt-8 grid grid-cols-1 items-center gap-4 border-t border-brand-border pt-6 text-xs text-zinc-400 sm:grid-cols-3">
          <div className="flex justify-center sm:justify-start">
            <img
              src={`${process.env.PUBLIC_URL}/logo_protorneos-15.svg`}
              alt="Protorneos"
              className="h-8 w-auto"
            />
          </div>
          <div className="flex items-center justify-center gap-3">
            {socialLinks.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="rounded-full border border-brand-border p-2 text-zinc-400 transition hover:border-brand-yellow hover:text-brand-yellow"
              >
                <Icon className="h-5 w-5" />
              </a>
            ))}
          </div>
          <p className="text-center sm:text-right">© {currentYear} Protorneos. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
